import { render, staticRenderFns } from "./familyList.vue?vue&type=template&id=1b073186&scoped=true"
import script from "./familyList.vue?vue&type=script&lang=js"
export * from "./familyList.vue?vue&type=script&lang=js"
import style0 from "./familyList.vue?vue&type=style&index=0&id=1b073186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b073186",
  null
  
)

export default component.exports